unit search.dieseldepots;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, WEBLib.ExtCtrls, Vcl.Controls, VCL.TMSFNCTypes,
  VCL.TMSFNCUtils, VCL.TMSFNCGraphics, VCL.TMSFNCGraphicsTypes,
  VCL.TMSFNCGridCell, VCL.TMSFNCGridOptions, Data.DB, XData.Web.JsonDataset,
  XData.Web.Dataset, XData.Web.Client, VCL.TMSFNCCustomComponent,
  VCL.TMSFNCCustomGrid, VCL.TMSFNCGridDatabaseAdapter, VCL.TMSFNCCustomControl,
  VCL.TMSFNCCustomScrollControl, VCL.TMSFNCGridData, VCL.TMSFNCGrid, WEBLib.DB,
  Vcl.StdCtrls, WEBLib.StdCtrls, WEBLib.Buttons, WEBLib.TMSWEBCustomComponent,
  WEBLib.TMSWEBStateManager, WEBLib.TMSWEBResponsiveManager;

type
  TfrmSearchDieselDepots = class(TWebForm)
    wcSearch: TXDataWebClient;
    qSearch: TXDataWebDataSet;
    dsSearch: TWebDataSource;
    qSearchNo: TIntegerField;
    qSearchName: TStringField;
    qSearchSuspended: TBooleanField;
    wpMain: TWebPanel;
    WebLabel1: TWebLabel;
    gSearch: TTMSFNCGrid;
    gdaSearch: TTMSFNCGridDatabaseAdapter;
    WebResponsiveManager1: TWebResponsiveManager;
    WebPanel1: TWebPanel;
    btnBack: TWebSpeedButton;
    btnSelect: TWebSpeedButton;
    weSearch: TWebEdit;
    procedure btnBackClick(Sender: TObject);
    procedure btnSelectClick(Sender: TObject);
    procedure qSearchAfterOpen(DataSet: TDataSet);
    procedure weSearchChange(Sender: TObject);
    procedure gSearchClick(Sender: TObject);
  private
    { Private declarations }

  public
    { Public declarations }
    bSuspended : Boolean;
    sCode,
    sName : String;
    procedure GetData;
  end;

var
  frmSearchDieselDepots: TfrmSearchDieselDepots;

implementation

{$R *.dfm}

uses
  stfmssystem.connection;

procedure TfrmSearchDieselDepots.btnBackClick(Sender: TObject);
begin
  sCode := '';
  sName := '';
  Close;
end;

procedure TfrmSearchDieselDepots.btnSelectClick(Sender: TObject);
begin
  sCode := qSearch.FieldByName('No').AsString;
  sName := qSearch.FieldByName('Name').AsString;
  Close;
end;

procedure TfrmSearchDieselDepots.GetData;
  procedure OnResult(Response : TXDataClientResponse);
  begin
    qSearch.Close;
    qSearch.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
    qSearch.Open;
  end;
begin
  wcSearch.RawInvoke('IstfmssearchService.GetDieselDepots', [bSuspended, -1], @OnResult);
  weSearch.SetFocus;
end;

procedure TfrmSearchDieselDepots.gSearchClick(Sender: TObject);
begin
  weSearch.Text := '';
  weSearch.SetFocus;
end;

procedure TfrmSearchDieselDepots.qSearchAfterOpen(DataSet: TDataSet);
begin
  gdaSearch.Active := True;
end;

procedure TfrmSearchDieselDepots.weSearchChange(Sender: TObject);
begin
  if weSearch.Text <> '' then
    begin
      case gSearch.Selection.StartCol of
        0 : qSearch.Locate('No', weSearch.Text, [loPartialKey]);
        1 : qSearch.Locate('Name', weSearch.Text, [loPartialKey]);
      end;
    end;
end;

end.
